import { Inline, xcss } from '@atlaskit/primitives';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import React, { Fragment, useCallback, useState } from 'react';
import { Sidebar } from '../Sidebar';
import { FiltersSelect } from './FiltersSelect';
import { SortSelect } from './SortSelect';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const wrapperStyles = xcss({
  flex: 1,
  minHeight: '0'
});
export const FiltersPanel = _ref => {
  var _filterDefinitions$, _filterOptions$select, _selectedOptions$sele;
  let {
    filterDefinitions,
    filterOptions,
    selectedOptions = {},
    sortOptions,
    selectedSortOption,
    filterStatus = {},
    onSelectedOptionsChange,
    onSelectedSortOptionChange
  } = _ref;
  const {
    enableAppificationChanges
  } = useStatsig();
  const defaultSelectedOptionId = sortOptions.length > 0 ? 'sort-by' : (_filterDefinitions$ = filterDefinitions[0]) === null || _filterDefinitions$ === void 0 ? void 0 : _filterDefinitions$.filterId;
  const [selectedSidebarOptionId, setSelectedSidebarOptionId] = useState(defaultSelectedOptionId);
  const selectedFilterDefinition = filterDefinitions.find(filterDefinition => filterDefinition.filterId === selectedSidebarOptionId);
  const handleSidebarOptionClick = useCallback(id => {
    if (id !== selectedSidebarOptionId) {
      setSelectedSidebarOptionId(id);
    }
  }, [selectedSidebarOptionId]);
  return /*#__PURE__*/_jsxs(Inline, {
    xcss: wrapperStyles,
    alignBlock: "stretch",
    children: [/*#__PURE__*/_jsx(Sidebar, {
      filterDefinitions: filterDefinitions,
      selectedSidebarOptionId: selectedSidebarOptionId,
      selectedOptions: selectedOptions,
      onSidebarOptionClick: handleSidebarOptionClick,
      enableSort: sortOptions.length > 0,
      enableAppification: enableAppificationChanges()
    }), /*#__PURE__*/_jsx(Fragment, {
      children: selectedSidebarOptionId === 'sort-by' ? /*#__PURE__*/_jsx(SortSelect, {
        options: sortOptions,
        selectedOption: selectedSortOption !== null && selectedSortOption !== void 0 ? selectedSortOption : sortOptions[0],
        onSelectedOptionChange: onSelectedSortOptionChange
      }) : selectedFilterDefinition && /*#__PURE__*/_jsx(FiltersSelect, {
        filterDefinition: selectedFilterDefinition,
        filterStatus: selectedSidebarOptionId ? filterStatus[selectedSidebarOptionId] : 'default',
        options: (_filterOptions$select = filterOptions[selectedSidebarOptionId]) !== null && _filterOptions$select !== void 0 ? _filterOptions$select : [],
        selectedOptions: (_selectedOptions$sele = selectedOptions[selectedSidebarOptionId]) !== null && _selectedOptions$sele !== void 0 ? _selectedOptions$sele : [],
        onSelectedOptionsChange: onSelectedOptionsChange
      })
    }, selectedSidebarOptionId)]
  });
};